import React from 'react';

import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';

import { ListItem } from './ListItem.styled';

import { Rectangle } from './Loader.styled';

const ParticipantItemLoader = (props) => (
  <ListItem>
    <ListItemAvatar>
      <Rectangle width={40} height={40} {...props} />
    </ListItemAvatar>
    <ListItemText
      primary={<Rectangle width={160} height={10} {...props} />}
      secondary={<Rectangle width={120} height={10} {...props} />}
    />
  </ListItem>
);

const ParticipantListLoader = () => (
  <React.Fragment>
    <ParticipantItemLoader opacity={0.6} />
    <ParticipantItemLoader opacity={0.5} />
    <ParticipantItemLoader opacity={0.4} />
    <ParticipantItemLoader opacity={0.3} />
  </React.Fragment>
);

export default ParticipantListLoader;
